const confirmationCodeEN = {
	title: "Confirm Account",
	subtitle: "Enter the code sent to your email",
	email: "Email",
	code: "Confirmation Code",
	button: "Confirm",
	loading: "Confirming...",
	resendCode: "Resend Code",
	sendingCode: "Sending...",
	backToLogin: "Back to Sign In",
};
export default confirmationCodeEN;
